export const RENALIFE_INFO =
  "RENALIFE MÉXICO — expansión de RENALIFE DO BRASIL. Suplementos naturales de bienestar:\n" +
  "• Kit Renalife (agua hidrogenada + Celunoma) — $3,200 MXN\n" +
  "• Amazonia Café (Ganoderma + Ashwaganda)\n" +
  "• Combo Premium (Nefro X1/X2 + Celunoma + café Moka + café Capuchino)\n" +
  "Dirigido a emprendedores mexicanos de 28 a 55 años, padres/madres de familia y profesionistas independientes " +
  "que buscan libertad financiera y bienestar integral. Tono aspiracional, humano y honesto (sin promesas de ingresos garantizados).";

export const OBJECTIVES = [
  { id: "branding", label: "Posicionamiento de marca", desc: "Dar a conocer y posicionar tu marca." },
  { id: "recruit", label: "Reclutar nuevos distribuidores/vendedores", desc: "Atraer personas a tu equipo." },
  { id: "sell_products", label: "Vender productos", desc: "Generar ventas de tus productos." },
  { id: "sell_services", label: "Vender servicios", desc: "Generar contrataciones de tus servicios." },
];

export const ChoiceCard = ({ active, onClick, icon: Icon, title, desc, testid }) => (
  <button
    type="button"
    data-testid={testid}
    onClick={onClick}
    className={`text-left rounded-2xl border p-6 transition-all hover:-translate-y-0.5 ${active ? "border-purple-500 bg-purple-600/10" : "border-white/10 bg-[#121212] hover:border-purple-500/50"}`}
  >
    <Icon className={active ? "text-yellow-400" : "text-purple-400"} size={28} />
    <h3 className="font-display font-bold text-lg mt-3">{title}</h3>
    <p className="text-sm text-zinc-400 mt-1">{desc}</p>
  </button>
);
